<template>
    <div class="component">
        <div v-if="user">
            <b-link
                :id="`avatar-${commentId}`"
                :to="`/v2/profile/${user.id}`"
                style="text-decoration: none"
            >
                <avatar
                    :src="user.picture"
                    :username="user.name"
                    :backgroundColor="avatarColor"
                    :size="54"
                    class="avatar"
                    color="white"
                />
                <b-badge
                    pill
                    :style="{ background: avatarColor }"
                    class="score"
                    >{{ getScore }}</b-badge
                >
            </b-link>
            <b-tooltip :target="`avatar-${commentId}`">
                {{ user.name }}
            </b-tooltip>
        </div>
        <div v-else>
            <avatar
                :src="null"
                :initials="getScore"
                :backgroundColor="avatarColor"
                :size="54"
                class="avatar"
                color="white"
            />
        </div>
        <div v-if="!withoutLine" class="line" />
    </div>
</template>
<script>
import Avatar from 'vue-avatar'

export default {
    components: {
        Avatar,
    },
    props: {
        commentId: String | Number,
        score: {
            type: String | Number,
            required: true,
        },
        user: {
            type: Object,
        },
        withoutLine: {
            type: Boolean,
            default: false,
        },
        avatarColor: {
            type: String,
            required: true,
        },
    },
    computed: {
        getScore() {
            return this.score.toString()
        },
    },
}
</script>
<style lang="scss" scoped>
.component {
    position: relative;
}

.line {
    display: block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 30px;
    height: calc(100%);
    width: 4px;
    background: #e4e5e6;
}

.avatar {
    z-index: 1;
    display: flex;
    position: relative;
    font-weight: bold !important;
}

.score {
    position: absolute;
    margin-top: -60px;
    margin-left: 40px;
    z-index: 1;
    font-size: 12px;
    color: #ffffff;
}
</style>
